/**
 * "Arrive 30 minutes before" as a readable phrase.
 *
 * The API stores minutes before start (0–1440). Rendered in hours once the
 * value divides cleanly, since "2 hours before" reads better than "120 minutes
 * before". Returns '' for null/zero/invalid so callers can hide the row.
 */
export const formatArrivalTime = (
  minutes: number | null | undefined
): string => {
  if (
    typeof minutes !== 'number' ||
    !Number.isFinite(minutes) ||
    minutes <= 0
  ) {
    return ''
  }

  const whole = Math.round(minutes)

  if (whole < 60) {
    return `${whole} ${whole === 1 ? 'minute' : 'minutes'} before`
  }

  const hours = whole / 60
  if (Number.isInteger(hours)) {
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} before`
  }

  const wholeHours = Math.floor(hours)
  const remainder = whole - wholeHours * 60
  return `${wholeHours}h ${remainder}m before`
}
